$(function(){

    $('#accordionEmployees').on("click", 'button.btn-link', function(e){
        e.preventDefault();

        var elem = $(this);
        var selector = elem.attr('aria-controls');

        resetAccordion(selector);

        var target = $('#'+selector);
        var expanded = elem.attr('aria-expanded');
        var link = $('#buttonEmployee');
        var employee_name = elem.find('span').html();
        link.find('.btn').attr('data-employee', employee_name);

        if(expanded === "false") {
            var emp_id = target.data('employee');
            var wp_id = $('#workplace-select').val();

            elem.append('<img src="/images/loading.gif" class="spinner ml-1" width="20px" alt="loading">');
            $.post("/ajax/employees/get", {'employee_id': emp_id, 'workplace_id': wp_id}, function (json) {
                var modal = $('#docsModal');
                elem.find('.spinner').remove();

                //Cards
                modal.find('.modal-body').find('#tab-2-1').html(json.view_card_1);
                modal.find('.modal-body').find('#tab-2-2').html(json.view_card_2);
                modal.find('.modal-body').find('#tab-2-3').html(json.view_card_3);
                modal.find('.modal-body').find('#tab-2-4').html(json.view_card_4);

                //Tree
                target.find('.card-body').html(json.view_tree + link[0].innerHTML);
                initFileTree(target);

                //target.collapse('show');
                target.addClass('show');
                elem.attr('aria-expanded', 'true');
                elem.removeClass('collapsed');
            }, 'json');
        }else{
            //target.collapse('hide');
            target.removeClass('show');
            elem.addClass('collapsed');
            elem.attr('aria-expanded', 'false');
            target.find('.card-body').empty();
        }
    });

    $('#employeeModalDel').on('shown.bs.modal', function () {
        $(this).find('.workplace-select-del').trigger('change');
        $(this).find('button.submit').attr('disabled', 'disabled');
    });

    $('#employeeModalSign').on('shown.bs.modal', function () {
        $(this).find('.workplace-select-sign').trigger('change');
        $(this).find('button.submit').attr('disabled', 'disabled');
    });

    $('#workplaceSelect').selectpicker({
        'title' : Lang.get('messages.select_workplaces'),
        'selectedTextFormat' : 'count',
        'lang' : Lang.getLocale()
    });

    $('#skillSelect').selectpicker({
        'title' : Lang.get('messages.undefined_skills'),
        'iconBase' : 'FontAwesome',
        'selectedTextFormat' : 'count',
        'lang' : Lang.getLocale(),
    });

    $('#employeeModalAdd').on('shown.bs.modal', function () {
       $(this).find('form')
           .trigger('reset')
           .validate().resetForm();

       $('#workplaceSelect').selectpicker('deselectAll');
       $('#skillSelect').find('optgroup').remove();
       $('#skillSelect').selectpicker('refresh');
       $(this).find('button[type="submit"]').removeAttr('disabled');
    });

    $('#employeeModalDel .workplace-select-del').change(function(){
        $.post("/ajax/employees/find", { workplace_id: $(this).val() }, function(json) {
            if(json.success === true){
                $('#tableEmployeeDelete').html(json.data);
            }
        }, "json");
    });

    $('#tableEmployeesTemp').find('.btn-cancel').on('click', function(){
        Swal.fire({
            title: 'Segur que vols cancel·lar aquesta sol·licitud d\'alta de treballador?',
            text: "Aquesta acció donarà de baixa la sol·licitud d'alta del treballador.",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, cancel·la la sol·licitud.'
        }).then((result) => {
            if (result.isConfirmed) {
                $.post("/ajax/employees/cancel-create", {employee_id: $(this).data('id')}, function (json) {
                    $.toast({
                        text: json.message,
                        icon: json.icon,
                        duration: 2000,
                        position: 'bottom-right'
                    });
                    if (json.success === true) {
                        window.setTimeout(function () {
                            window.location.reload();
                        }, 2000);
                    }
                }, "json");
            }
        });
    });

    $('#employeeModalSign .workplace-select-sign').change(function(){
        //Elimino tooltips
        $('#tableEmployeeSign [data-toggle="tooltip"]').tooltip('dispose');

        //Substitueixo contringut x un spinner
        $('#tableEmployeeSign').html('' +
            '<div class="my-4 text-center">' +
            '   <img src="/images/loading.gif" style="max-width: 50px" alt="loading">' +
            '</div>');

        //Carrego dades
        $.post("/ajax/employees-sign/find", { workplace_id: $(this).val() }, function(json) {
            if(json.success === true){
                $('#tableEmployeeSign').html(json.data);
                $('#tableEmployeeSign [data-toggle="tooltip"]').tooltip()
            }
        }, "json");
    });

    $('#employeeModalDel, #employeeModalSign').on('change', 'input[type="checkbox"]', function(){
        let modal = $(this).closest('.modal');
        modal.find('button.submit').attr('disabled', function(){
            return (modal.find('input[type="checkbox"]:checked').length < 1)
        });
    });

    $('#employeeModalDel').on('hidden.bs.modal', function (e) {
        window.location.reload();
    });

    $('#employeeModalDel button.submit').click(function(e){
        e.preventDefault();
        let modal = $('#employeeModalDel');
        let ids = modal.find(':input[type="checkbox"]:checked').serializeArray();
        let myDate = modal.find('input.datepicker').val();

        if(window.moment(myDate, 'DD/MM/YYYY', true).isValid()){
            modal.find('button.submit').attr('disabled', 'disabled');
            $.post("/ajax/employees/delete", { ids: ids, date: myDate }, function(json) {
                modal.find('.workplace-select-del').trigger('change');
                $.toast({
                    text: json.message,
                    icon: 'success',
                    position: 'bottom-right'
                });
            }, "json");
        }else{
            $.toast({
                text: "Revisa el format de la data de baixa",
                icon: 'warning',
                position: 'bottom-right'
            });
        }
    });

    $('#employeeModalSign button.submit').click(function(e){
        e.preventDefault();
        let modal = $('#employeeModalSign');
        let ids = modal.find(':input[type="checkbox"]:checked').serializeArray();

        modal.find('button.submit').attr('disabled', 'disabled');
        $.post("/ajax/employees-sign/send", { ids: ids }, function(json) {
            modal.find('.workplace-select-sign').trigger('change');
            $.toast({
                text: json.message,
                icon: 'success',
                position: 'bottom-right'
            });
        }, "json");
    });

    $('#employeeModalDel').on("click", 'a.delete-employee', function(e){
        if(confirm(Lang.get('messages.sure_to_delete'))) {
            let employee_id = $(this).data('id');
            let modal = $('#employeeModalDel');
            $.post("/ajax/employees/cancel-delete", { employee_id: employee_id }, function(json) {
                modal.find('.workplace-select-del').trigger('change');
                $.toast({
                    text: json.message,
                    icon: 'success',
                    position: 'bottom-right'
                });
            }, "json");
        }
    });

    $('#workplaceSelect').change(function(){
        var ddSkills = $('#skillSelect');
        $.post("/ajax/employee/getskills", { workplaces: $(this).val() }, function(json) {
            if(json.success === true){
                ddSkills.empty();
                $.each(json.groups, function(group_id, values){
                    let group = json.workplaces[group_id];
                    let optgroup = $('<optgroup data-icon="icon icon-industry" label="'+group.full_name+'"></optgroup');
                    $.each(values, function(key, name){
                       optgroup.append('<option value="'+key+'">'+name+'</option>');
                    });
                    ddSkills.append(optgroup);
                });
                ddSkills.selectpicker('refresh');
            }
        }, 'JSON');
    });

    //Si el treballador és administrador no té ni centre ni lloc de treball obligatori.
    //La part de "required" es fa desde el plugin amb la funció "depends".
    $('#relationship').on("change", function(){
        const lc = $('label[for="lloc_treball"]');
        const lca = $('label[for="lloc_treball_alternatiu"]');
        lc.html(lc.html().replace("*", ""));
        lca.html(lca.html().replace("*", ""));
        if($(this).val() !== 'D'){
            lc.html(lc.html() + " *");
            lca.html(lca.html() + " *");
        }
    });

    //Si tenim lloc de treball alternatiu entrat no cal marcar els llocs de treball (sempre que no sigui admin)
    $('#lloc_treball_alternatiu').on("keyup", function(){
        const lc = $('label[for="lloc_treball"]');
        lc.html(lc.html().replace("*", ""));
        if($(this).val().length === 0 && $('#relationship').val() !== 'D'){
            lc.html(lc.html() + " *");
        }
    });

    //Si no tenim lloc de treball marcat, llavors hem de marcar per força el lloc de treball alternatiu
    $("#skillSelect").on("change", function(e) {
        console.log($(this).val().length);
        const lca = $('label[for="lloc_treball_alternatiu"]');
        lca.html(lca.html().replace("*", ""));
        if($(this).val().length === 0 && $('#relationship').val() !== 'D'){
            lca.html(lca.html() + " *");
        }
    });


    const mail_required = $('#email').data('required');
    const phone_required = $('#phone_number').data('required');
    $('#formNewEmployee').validate({
        'lang' : Lang.getLocale(),
        submitHandler: function(form) {
            let modal = $('#employeeModalAdd');
            modal.find('button[type="submit"]').attr('disabled', 'disabled');

            $(form).ajaxSubmit({
                url: '/ajax/employees/store',
                dataType: 'json',
                success: function (json, textStatus) {
                    if(json.success === true){
                        modal.find('form').trigger('reset');
                        $.toast({
                            text: json.message,
                            icon: 'success',
                            position: 'bottom-right'
                        });
                        if(json.view === false){
                            window.setTimeout(function(){
                                modal.modal('hide');
                                window.location.reload();
                            }, 1000);
                        }else{
                            Swal.fire(
                                Lang.get('messages.good_job'),
                                json.view,
                                'success'
                            ).then((result) => {
                                window.location.reload();
                            });
                        }
                    }else{
                        $(form).find('button[type="submit"]').removeAttr('disabled');
                        $.toast({
                            text: json.message,
                            icon: 'warning',
                            position: 'bottom-right'
                        });
                    }
                }
            });
            return false;
        },
        rules: {
            nom: {
                required: true,
            },
            cognoms: {
                required: true,
            },
            email: {
                required: mail_required,
                email: true
            },
            data_alta_empresa: {
                required: true,
                dateISO: true,
                minDate: '1900-01-01',
                /*lessThanToday: true*/
            },
            telefon: {
                required: phone_required,
            },
            dni: {
                required: true,
                remote: {
                    param: {
                        url: "/ajax/employees/checkDNI",
                        type: "post",
                        complete: function(data) {
                            if (data.responseText === "true") {
                                let dni = $('#dni').val();
                                $.post( "/ajax/employees/checkDismissed", { 'dni' : dni }, function(json) {
                                    if(json.success === true) {
                                        Swal.fire({
                                            title: Lang.get('messages.attention'),
                                            html: Lang.get('messages.recover_message'),
                                            showCancelButton: true,
                                            cancelButtonText : 'No',
                                            confirmButtonText: Lang.get('messages.recover_button_text'),
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                $('#formNewEmployee #nom').val(json.data.nom);
                                                $('#formNewEmployee #cognoms').val(json.data.cognoms);
                                                $('#formNewEmployee #email').val(json.data.email);
                                                $('#formNewEmployee #phone_number').val(json.data.telefon);
                                                $('#formNewEmployee #ss').val(json.data.ss);
                                                $('#formNewEmployee #data_naixement').val(json.data.naixement);
                                                $('#formNewEmployee input:radio[name=sexe]').filter('[value='+json.data.sexe+']').prop('checked', true);
                                            }
                                        });
                                    }
                                }, 'json');
                            }
                        }
                    },
                    depends: function() {
                        return isSpanish();
                    }
                }
            },
            data_naixement: {
                required: true,
                dateISO: true
            },
            "centre_treball[]": {
                required: true
            },
            "lloc_treball[]": {
                required: {
                    depends: function() {
                        return (($('#relationship').val() !== 'D') && ($('#lloc_treball_alternatiu').val().length === 0));
                    }
                }
            },
            "lloc_treball_alternatiu": {
                required: {
                    depends: function(){
                        return (($('#relationship').val() !== 'D') && ($('#skillSelect').val().length === 0));
                    }
                },
            }
        }
    });
});

$('#docsModal').on('show.bs.modal', function (event) {
    let button = $(event.relatedTarget);
    let employee = button.data('employee');
    $(this).find('.modal-title').text(employee);
    $('[data-toggle="tooltip"]').tooltip();
});

$('#nacionalitat').on("change", function(e){
    e.preventDefault();
    let label = (isSpanish()) ? 'DNI / NIE *' : 'DOC. ID. *';
    $("label[for='dni']").html(label);
    $('#dni').attr('placeholder', label);
});

$(document).on("submit", '#formUpdateEmployee', function(e){
    e.preventDefault();
    let data = $(e.target).serializeArray();
    $.post(e.target.action, data, function(json) {
        $.toast({
            text: json.message,
            icon: (json.success === true) ? 'success' : 'warning',
            position: 'bottom-right'
        });
    }, "json");
});

function isSpanish(){
    return $('#nacionalitat').val() === "0"
}

function resetAccordion(curSelector){
    $('#accordionEmployees').find('.card').each(function(){
        var card = $(this);
        var link = $(this).find('.btn-link');
        var selector = link.attr('aria-controls');
        var target = $('#'+selector);
        var expanded = link.attr('aria-expanded');

        if(expanded === "true" && selector !== curSelector){
            target.collapse('hide');
            link.attr('aria-expanded', 'false');
            link.addClass('collapsed');
            card.removeClass('active');
            card.find('.card-body').empty();
        }
    });
}

function initFileTree(target){
    var folder = $(target).find('.file-tree li.file-tree-folder');
    var file = $(target).find('.file-tree li');

    folder.on("click", function(a) {
        $(this).children('ul').slideToggle(400, function() {
            $(this).parent("li").toggleClass("open")
        }), a.stopPropagation()
    });

    file.on('click', function(b){
        b.stopPropagation();
    });
}
